const orderStatusLabels: Readonly<Record<string, string>> = {
  CREATED: 'Aguardando aceitação',
  CONFIRMED: 'Pedido aceito',
  PREPARING: 'Em preparo',
  READY: 'Pronto',
  AWAITING_PICKUP: 'Aguardando retirada',
  ASSIGNED_TO_COURIER: 'Entregador atribuído',
  OUT_FOR_DELIVERY: 'Em entrega',
  DELIVERED: 'Entregue',
  CANCELLED: 'Cancelado'
};

export function publicOrderStatusLabel(status: string): string {
  return orderStatusLabels[status] ?? 'Situação do pedido indisponível';
}

export function publicErrorLabel(code: string | undefined): string {
  const messages: Readonly<Record<string, string>> = {
    ONLINE_ORDERS_PAUSED: 'Os pedidos pela internet estão temporariamente pausados.',
    STORE_CLOSED: 'O estabelecimento está fechado no momento.',
    PICKUP_DISABLED: 'A retirada está indisponível no momento.',
    DELIVERY_DISABLED: 'A entrega está indisponível no momento.',
    DELIVERY_AREA_UNAVAILABLE: 'O endereço está fora das áreas de entrega disponíveis.',
    ORDER_NOT_FOUND: 'Não foi possível localizar o pedido.',
    ORDER_TOKEN_REQUIRED: 'Não foi possível consultar este pedido.',
    RATE_LIMITED: 'Muitas tentativas em pouco tempo. Aguarde e tente novamente.',
    VALIDATION_ERROR: 'Confira os dados informados e tente novamente.',
    SETUP_REQUIRED: 'Os pedidos pela internet ainda não estão configurados.'
  };
  return code === undefined
    ? 'Não foi possível concluir a solicitação.'
    : (messages[code] ?? 'Não foi possível concluir a solicitação.');
}
